import requester from '@/lib/axios';
import ActivityProgress, {
  ActivityProgressShortView,
} from '@/models/_deprecated/ActivityProgress';
import { ActivityProgressFilterParams } from '@/data/services/activityProgressServices';
import JsonApiResponse from '@/models/JsonApiResponse';

/** @deprecated Use listActivityProgress from @/data/services/activityProgressServices */
export async function listActivityProgress(
  params: ActivityProgressFilterParams = {},
) {
  const { data } = await requester().get<JsonApiResponse<ActivityProgress>>(
    'activity-progress/',
    {
      params,
    },
  );

  return data;
}

/** @deprecated Typed with `@/models/_deprecated/ActivityProgress`. No replacement yet. */
export async function listActivityProgressShortView(
  params: ActivityProgressFilterParams = {},
) {
  const { data } = await requester().get<
    JsonApiResponse<ActivityProgressShortView>
  >('activity-progress/short-view/', {
    params,
  });

  return data;
}

/** @deprecated Use getActivityProgress from @/data/services/activityProgressServices */
export const getActivityProgress = async (activityProgressId: number) => {
  const { data } = await requester().get<ActivityProgress>(
    `activity-progress/${activityProgressId}/`,
  );

  return data;
};

/** @deprecated Typed with `@/models/_deprecated/ActivityProgress`. No replacement yet. */
export const updateActivityProgress = async (
  activityProgressId: number,
  activityProgress: Partial<ActivityProgress>,
) => {
  const { data } = await requester().patch<ActivityProgress>(
    `activity-progress/${activityProgressId}/`,
    activityProgress,
  );
  return data;
};
